$(document).on('click', 'form .pwd-group i', function () {
  $(this).parent().find('input.form-control').attr('type', (_, attr) => attr == 'password' ? 'text' : 'password')
  $(this).attr('class', (_, attr) => attr == 'fas fa-eye' ? 'fas fa-eye-slash' : 'fas fa-eye')
})
